// extracted by mini-css-extract-plugin
export default {"info":"styles_info__pz-yz","tab":"styles_tab__8vHQf","btn":"styles_btn__6XqtI"};